<!--
bellow is the table  -->

<div class="container-fluid pagecard employee-main" id="employee-list-page">
    <learn-more [title]="'Referral Statistic' | translate | async"
        link="https://support.eatos.com/en-us/article/dashboard-employee-employees-2abmd3/"
        [content]="'Addressing issues and enhancing performance.' | translate | async"></learn-more>
    <div class="" style="width:auto">
        <div class="row justify-content-end">
            <!-- <div class="col-auto">
                <button class="new-btn" style="position: relative; right: 10px; top: -25px" (click)="goToAddPage()">
                    + {{ "Create Ticket" | translate | async }}
                </button>
            </div> -->
        </div>
        <div class="row">
            <!-- Total Referral -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Total Earnings
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Shows total of Referral Earnings' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Total Earning' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18"> {{currency}}{{this.totalCount}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Open Referral -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Pending Earning
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'A number of Pending Earning needing a Referral' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Pending Earning' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{currency}}{{this.totalPending}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/transactions-icon.svg">
                        </div>
                    </div>
                </div>
            </div>

            <!-- Closed Referral -->
            <div class="col-12 col-md-4">
                <div class="mini-card">
                    <div class="row g-0">
                        <div class="col-8">
                            <div class="f-14 mb-1 fw-600">
                                Total Referral
                                <i style="padding:2px" class="f-10 fas fa-info-circle vertical-align-super"
                                    [ngbPopover]=" 'Total number of Referral.' | translate | async"
                                    triggers="mouseenter:mouseleave"
                                    [popoverTitle]="'Total Referral' | translate | async" placement="right"></i>
                            </div>
                            <h6 class="fw-600 f-18">{{this.totalComplate}}</h6>
                        </div>
                        <div class="col-4 text-end align-self-center">
                            <img src="assets/images/sale-icon.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
        <!-- <div class="mb-3 flex-wrap">
            <div
              class="datepickerwrap form-control"
              daterangepicker
              [options]="options"
              (selected)="selectedDate($event)"
              style="max-width: 290px !important; position: relative"
              (click)="setDateTexts()"
            >
              <span
                ><span class="display-date">{{ startDateDisplayFormatted | translate | async }}</span> -
                <span class="display-date">{{ endDateDisplayFormatted | translate | async }}</span>
                </span
              >
              <img
                src="../../../../assets/fonts/bx-calendar.svg"
                class="ms-2 me-0"
                style="position: absolute; right: 0"
              />
            </div>
          </div> -->
        <!-- <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active"> -->
        <!-- <ng-container [ngbNavItem]="1"> -->
        <!-- <a ngbNavLink> {{ 'Active' | translate | async }}</a> -->
        <!-- <ng-template ngbNavContent> -->
        <!-- empty list UI -->
        <div class="empty-courses" *ngIf="isEmpty">
            <div class="text-center">
                <img src="assets\images\Employees.svg" class="mb-2" />
                <h2 class="fw-600 mb-4">{{ 'Referral Statistic' | translate | async }}</h2>
                <p class="f-16 mb-5"> {{ 'No Referral Statistic Data Present' | translate | async }}</p>
                <!-- accessControl module="Employee" access="3" -->
                <!-- <button class="create-btn" (click)="goToAddPage()">
                    {{ 'Create Ticket(s)' | translate | async }}
                </button> -->
            </div>
        </div>

        <!--  table UI -->
        <div *ngIf="!isEmpty" [ngClass]="isEmpty ? 'isEmpty' : ''" class="position-relative" style="margin-top: -15px">
            <div class="table-responsive employees-table2 archive-data">
                <table id="employees-table" class="display table-make-responsive" cellspacing="0" width="100%" datatable
                    [dtOptions]="dtOptions">

                    <thead class="make-table-resp" style="border-top: 1px solid #6666;">
                        <tr>
                            <th class="text-center"> Refer By </th>
                            <th class="text-center"> Mobile </th>
                            <th class="text-center"> Referral Code </th>
                            <th class="text-center"> Referral Merchant Name </th>
                            <th class="text-center"> Referral Merchant Mail </th>
                            <th class="text-center"> Referral Merchant Mobile </th>  
                            <th class="text-center"> Referral Amount</th>
                            <th class="text-center"> Earning Status </th>
                            <th class="text-center"> Created At </th>
                            <!-- <th class="text-center"> Created At </th>
                            <th class="text-center"> Status </th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let employee of employees; let i = index" class="table-row" style="cursor: pointer" (click)="employee.earningStatus !== 1 ? openReferralPayment(employee._id) : null">
                            <td>{{ employee.employeeName || 'No employeeName Available' }}</td>
                            <td>{{ employee.employeeMobile || 'No employeeMobile Available' }}</td>
                            <td>{{ employee.referralCode || 'No ReferralCode Available' }}</td>
                            <td>{{ employee.referralMerchantName || 'No Referral Merchant Name Available' }}</td>
                            <td>{{ employee.merchantEmail || 'No Referral Mail Available' }}</td>
                            <td>{{ employee.merchantMobile || 'No Referral Mobile Available' }}</td>
                            <td>{{currency}}{{ employee.referralAmount || 'No Referral Amount Available' }}</td>
                            <td style="font-size: 14px; color: #000;">
                                {{ employee.earningStatus === 0 ? 'Pending' : 'Completed' }}
                            </td>
                            <td class="text-center">
                                {{ _convertDate(employee.employeeId, employee.createdAt) }} {{ convertTime(employee.createdAt) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #referralPayment let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ 'Update Payment Information' | translate | async }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="referralForm" (keydown.enter)="$event.preventDefault()" autocomplete="off">
        <div formGroupName="referralPayment">
  
          <!-- Payment Reference Number -->
          <div class="mb-3 row align-items-center">
            <label for="paymentReferenceNumber" class="col-sm-5 col-form-label">
              {{ 'Enter Payment Reference Number*' | translate | async }}
            </label>
            <div class="col-sm-7">
            <input type="text" class="form-control" id="paymentReferenceNumber" formControlName="paymentReferenceNumber"
                placeholder="Enter Payment Reference">
            <div class="form-text text-danger" *ngIf="isControlInvalid('paymentReferenceNumber')">
                <span *ngIf="referralForm.get('referralPayment.paymentReferenceNumber').hasError('whiteSpace')">
                    {{ 'Reference number cannot be empty or whitespace only' | translate | async }}
                </span>
                <span *ngIf="referralForm.get('referralPayment.paymentReferenceNumber').hasError('required')">
                    {{ 'Please provide a valid Payment Reference Number' | translate | async }}
                </span>
            </div>
            </div>
          </div>
  
          <!-- Payment Amount -->
          <div class="mb-3 row align-items-center">
            <label for="referralAmount" class="col-sm-5 col-form-label">
              {{ 'Enter Payment Amount*' | translate | async }}
            </label>
            <div class="col-sm-7">
              <input type="number" class="form-control" id="referralAmount" formControlName="referralAmount" placeholder="Enter Payment Amount">
              <div class="form-text text-danger" *ngIf="isControlInvalid('referralAmount')">
                <span *ngIf="referralForm.get('referralPayment.referralAmount').hasError('min')">
                  {{ 'Minimum amount is 500' | translate | async }}
                </span>
                <span *ngIf="referralForm.get('referralPayment.referralAmount').hasError('max')">
                  {{ 'Maximum amount is 1000' | translate | async }}
                </span>
                <span *ngIf="referralForm.get('referralPayment.referralAmount').hasError('required')">
                  {{ 'Please provide a valid Payment Amount' | translate | async }}
                </span>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Submit and Cancel Buttons -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')">
            {{ 'Cancel' | translate | async }}
          </button>
          <button (click)="changeStatus(); modal.dismiss('cancel click')" class="btn btn-secondary custom-btn" [disabled]="!referralForm.valid">
            {{ 'Submit' | translate | async }}
          </button>
        </div>
      </form>
    </div>
  </ng-template>